// Material Dashboard 2 React components
import MDBox from "components/MDBox"
// Organizaciones page components
import OrganizacionItem from "layouts/asistencia/dependencias/components/OrganizacionItem"
import PropTypes from "prop-types"

function OrganizacionesInformation({ organizaciones, onReload }) {
  return (
    <MDBox pt={1} pb={2} px={2}>
      {organizaciones?.map((item) => (
        <div key={item.id}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            <OrganizacionItem
              key={item.id}
              id={item.id}
              nombre={item.nombre}
              sucursal={item.sucursalNombre}
              parentNombre={item.parentNombre}
              onReload={onReload}
            />
          </MDBox>
          <hr></hr>
        </div>
      ))}
    </MDBox>
  )
}

OrganizacionesInformation.propTypes = {
  organizaciones: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReload: PropTypes.func.isRequired,
}

export default OrganizacionesInformation
